import { db } from "../utils/db";
import type { StateStorage } from "zustand/middleware";
import { devLogger } from "@certa/common/utils/devLogger";
import type { MegaJSON } from "@certa/studio-core";

export const getMegaJSONFromPersistentStorage = async (
  branchSavepointId: string
) => {
  return db.megaJSON.get(branchSavepointId);
};

export const saveMegaJSONToPersistentStorage = async (megaJSON: MegaJSON) => {
  if (megaJSON.id === null) return; // before init state, we don't save
  return db.megaJSON.put(megaJSON);
};

export const persistentStorageForDBOpsStore: StateStorage = {
  getItem: async (storeName: string) => {
    // Not hydrating as we are using initialize to hydrate
    return null;
  },
  setItem: async (storeName: string, stateString: string) => {
    try {
      const parsedState = JSON.parse(stateString) as {
        state: { megaJSON: MegaJSON };
      } | null;

      const parsedMegaJSON = parsedState?.state.megaJSON;
      if (parsedMegaJSON) {
        await saveMegaJSONToPersistentStorage(parsedMegaJSON);
      }
    } catch (error) {
      devLogger.error("Error parsing state string:", error);
    }
  },
  removeItem: async (storeName: string) => {
    // Don't need this
  }
};
